import React from "react";

export const linkIdentifier = (txt) => {
  const tlds = [
    "com",
    "org",
    "net",
    "info",
    "biz",
    "online",
    "site",
    "xyz",
    "tech",
    "store",
    "io",
    "ai",
    "co",
    "us",
    "uk",
    "de",
    "fr",
    "au",
    "ca",
    "jp",
    "in",
    "gov",
    "edu",
    "tv",
    "me",
    "pro",
    "blog",
    "shop",
    "app",
    "dev",
    "bank",
    "banks",
    "cloud",
    "desi",
    "bharat",
    "airtel",
    "apple",
    "citi",
    "gbiz",
    "gle",
    "gmail",
    "google",
    "ril",
    "sbi",
  ];
  if (typeof txt === "object") return txt;
  const text = typeof txt === "string" ? txt : String(txt ?? "");
  if (!text.trim()) return null;

  const urlRegex = new RegExp(
    String.raw`\b((https?:\/\/|www\.)?[a-zA-Z0-9.-]+\.(?:${tlds.join("|")})(:\d+)?(\/[^\s]*)?)\b`,
    "gi",
  );

  const emailRegex = /\b[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}\b/g;

  const matches = [
    ...Array.from(text.matchAll(urlRegex)).map((m) => ({
      type: "url",
      start: m.index,
      end: m.index + m[0].length,
      value: m[0],
    })),
    ...Array.from(text.matchAll(emailRegex)).map((m) => ({
      type: "email",

      start: m.index,
      end: m.index + m[0].length,
      value: m[0],
    })),
  ].sort((a, b) => a.start - b.start);

  if (matches.length === 0) return <>{text}</>;

  const elements = [];
  let lastIndex = 0;

  matches.forEach((m, i) => {
    if (m.start < lastIndex) return;

    if (lastIndex < m.start) {
      elements.push(
        <React.Fragment key={`txt-${i}`}>
          {text.slice(lastIndex, m.start)}
        </React.Fragment>,
      );
    }

    if (m.type === "url") {
      let href = m.value;

      if (!href.startsWith("http://") && !href.startsWith("https://")) {
        if (href.startsWith("www.")) href = `https://${href}`;
        else href = `https://${href}`;
      }

      elements.push(
        <a
          key={`url-${i}`}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className="underline break-all"
          style={{ color: "var(--pending)" }}
        >
          {m.value}
        </a>,
      );
    }

    if (m.type === "email") {
      elements.push(
        <a
          key={`email-${i}`}
          href={`mailto:${m.value}`}
          className="underline break-all"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "var(--pending)" }}
        >
          {m.value}
        </a>,
      );
    }

    lastIndex = m.end;
  });

  if (lastIndex < text.length) {
    elements.push(
      <React.Fragment key="end-text">{text.slice(lastIndex)}</React.Fragment>,
    );
  }

  return elements;
};
